<script setup lang="ts">
import NavigationBar from './NavigationBar.vue';
import HeroSection from './HeroSection.vue';
import FeaturesGrid from './FeaturesGrid.vue';
import DemoSimulator from './DemoSimulator.vue';
import HowItWorksSection from './HowItWorksSection.vue';
import TestimonialsSection from './TestimonialsSection.vue';
import FaqSection from './FaqSection.vue';
import SiteFooter from './SiteFooter.vue';
</script>

<template>
  <div class="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
    <NavigationBar />
    <HeroSection />
    <DemoSimulator />
    <FeaturesGrid />
    <HowItWorksSection />
    <TestimonialsSection />
    <FaqSection />
    <SiteFooter />
  </div>
</template>
